module.exports = ".checkbox {\n    height: 20px;\n    width: 20px;\n}\n\n.checkboxLabel {\n    display: inline-block;\n}\n\n.checkIcon {\n    background-color: white;\n    border: 0;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/infractions/infraction.editor.component.css
 ** module id = 943
 ** module chunks = 0
 **/